module.exports = __webpack_public_path__ + "img/austin_24.5c1c1da8.png";